<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="81" height="77" viewBox="0 0 81 77" fill="none">
    <g clip-path="url(#clip0_3794_18160)">
      <path
        d="M43.2346 76.9992H41.187V53.5522C41.187 49.2103 40.1175 44.9692 38.0141 40.9497C35.8853 36.8849 32.7884 33.2281 28.8147 30.08L30.092 28.4883C34.2938 31.8127 37.5731 35.6911 39.8337 40.0128C42.0942 44.3245 43.2397 48.8829 43.2397 53.5522V76.9992H43.2346Z"
        fill="#2DA86D"
      />
      <path
        d="M47.4364 77.0034H45.3887V52.6698C45.3887 49.6225 45.561 46.424 45.9107 42.8881C46.0881 41.0999 46.4683 39.5385 47.7455 37.7302C48.967 35.9925 51.0451 34.0079 54.4765 31.293L55.7538 32.8846C49.0836 38.1634 48.2575 40.0472 47.9533 43.0845C47.6087 46.5499 47.4414 49.6829 47.4414 52.6648V76.9983L47.4364 77.0034Z"
        fill="#3B755F"
      />
      <path d="M0 0C0 0 7.80552 45.7507 31.5008 31.3047L0 0Z" fill="#2DA86D" />
      <path d="M0 0C0 0 46.0374 7.75692 31.5008 31.3047L0 0Z" fill="#3B755F" />
      <path
        d="M81.0001 5.73047C81.0001 5.73047 40.4621 12.5606 53.2652 33.2927L81.0001 5.73047Z"
        fill="#2DA86D"
      />
      <path
        d="M81.0006 5.73047C81.0006 5.73047 74.1276 46.0161 53.2656 33.2927L81.0006 5.73047Z"
        fill="#3B755F"
      />
    </g>
    <defs>
      <clipPath id="clip0_3794_18160">
        <rect width="81" height="77" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
